export const BOOT_LOGO_PATH = '/images/D.webp'
export const BOOT_LOGO_SIZE_PX = 124

export const bootLogoMarkup = () =>
	`<div class="boot-splash-logo-stage"><img src="${BOOT_LOGO_PATH}" alt="" class="boot-splash-logo" width="${BOOT_LOGO_SIZE_PX}" height="${BOOT_LOGO_SIZE_PX}" /></div>`

export const asBootError = (thrown: string | Error | object): Error =>
	thrown instanceof Error ? thrown : new Error(String(thrown))

export const escapeBootHtml = (value: string): string => value.replace(/</g, '&lt;')

export const bootFailureMarkup = (errorMessage: string) => `
	<div id="boot-failure" role="alert">
		<div class="boot-failure-panel">
			${bootLogoMarkup()}
			<div class="boot-failure-copy">
				<p class="boot-failure-title">Couldn&rsquo;t load Drippy</p>
				<p class="boot-failure-detail">The app failed to start. This is usually a temporary network issue.</p>
				<button type="button" class="btn btn-primary boot-failure-retry">Try again</button>
				<p class="boot-failure-hint">${escapeBootHtml(errorMessage)}</p>
			</div>
		</div>
	</div>
`
